import PrintContainer from '../../reusable/PrintContainer';
import CustomButton from '../../reusable/CustomButton';
import PrintIcon from '../../assets/print.svg';
import TranscriptPrintView from './TranscriptPrintView';
import useFetchData from '../../hooks/useFetchData';
import { getSubjectAreas } from '../../../services/eoaConfigServices';

import { TranscriptDetails } from '../../../interfaces/TranscriptsInterface';

interface TranscriptDetailsPrintButtonProps {
  data: TranscriptDetails;
}

function TranscriptDetailsPrintButton({ data }: TranscriptDetailsPrintButtonProps) {
  
  const { isPending: isSubjectAreasDataPending, error: subjectAreasDataError, data: subjectAreasData } = useFetchData({
    fetchData: (eoaId, access_token) => getSubjectAreas(access_token),
    errorMessage: 'Error occured while fetching subject areas!',
    initialState: []
  });

  if (subjectAreasDataError) return <p>Print unavailable!</p>;

  return (
    <PrintContainer
      printButton={(handlePrint) => (
        <CustomButton
          variant="text"
          buttonText="Print"
          icon={<img src={PrintIcon} alt="download"></img>}
          iconPosition="start"
          buttonAction={handlePrint}
          loading={isSubjectAreasDataPending}
          shouldShowUpdates={true}
        />
      )}
    >
      <TranscriptPrintView transcript={{ type: 'data', data}} subjectAreas={subjectAreasData} />
    </PrintContainer>
  );
}

export default TranscriptDetailsPrintButton;